(function () {
  var root = document.querySelector('[data-trp-home]');
  if (!root) return;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function pageTop(element) {
    return element.getBoundingClientRect().top + window.pageYOffset;
  }

  function normalizedPath(pathname) {
    return (pathname || '/').replace(/\/+$/, '') || '/';
  }

  function isProductJumpLink(link) {
    var rawHref = link.getAttribute('href') || '';
    if (rawHref === '#trp-home-products') return true;

    try {
      var url = new URL(link.href, window.location.href);
      return url.hash === '#trp-home-products' &&
        url.origin === window.location.origin &&
        normalizedPath(url.pathname) === normalizedPath(window.location.pathname);
    } catch (error) {
      return false;
    }
  }

  function closestProductSection(trigger) {
    var sections = [
      root.querySelector('#trp-home-products'),
      root.querySelector('#trp-home-pricing')
    ].filter(Boolean);

    if (!sections.length) return null;

    var triggerTop = pageTop(trigger);
    return sections.reduce(function (closest, section) {
      var distance = Math.abs(pageTop(section) - triggerTop);
      if (!closest || distance < closest.distance) {
        return {
          distance: distance,
          section: section
        };
      }

      return closest;
    }, null).section;
  }

  function stickyOffset() {
    var styles = window.getComputedStyle(document.documentElement);
    return parseFloat(styles.scrollPaddingTop) || 0;
  }

  function scrollToSection(section) {
    var top = Math.max(0, pageTop(section) - stickyOffset());

    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + section.id);
    }

    window.scrollTo({
      top: top,
      behavior: 'smooth'
    });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var trigger = event.target.closest ? event.target.closest('a') : null;
    if (!trigger || trigger.target || !isProductJumpLink(trigger)) return;

    var section = closestProductSection(trigger);
    if (!section) return;

    event.preventDefault();
    scrollToSection(section);
  });

  function setPlan(plan) {
    var tabs = toArray(root.querySelectorAll('[data-trp-plan-tab]'));
    var panels = toArray(root.querySelectorAll('[data-trp-plan-panel]'));
    var notes = toArray(root.querySelectorAll('[data-sub-note]'));

    tabs.forEach(function (tab) {
      var active = tab.getAttribute('data-trp-plan-tab') === plan;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    panels.forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-trp-plan-panel') !== plan;
    });

    notes.forEach(function (note) {
      var noteKey = plan === 'onetime' ? 'onetimeNote' : 'subscriptionNote';
      var noteText = note.dataset[noteKey] || '';
      note.innerHTML = noteText;
      note.classList.toggle('is-onetime', plan === 'onetime');
    });
  }

  toArray(root.querySelectorAll('[data-trp-plan-tab]')).forEach(function (tab) {
    tab.addEventListener('click', function () {
      setPlan(tab.getAttribute('data-trp-plan-tab'));
    });
  });

  function routeUrl(name, fallback) {
    var theme = window.Theme || {};
    var routes = theme.routes || {};
    return routes[name] || fallback;
  }

  function cartJsonUrl() {
    var cartUrl = routeUrl('cart_url', '/cart');
    return cartUrl.replace(/\/$/, '') + '.js';
  }

  function cartSectionIds() {
    return toArray(document.querySelectorAll('cart-items-component'))
      .map(function (component) {
        return component.getAttribute('data-section-id');
      })
      .filter(Boolean);
  }

  function setAddState(trigger, isAdding) {
    trigger.classList.toggle('is-loading', isAdding);
    trigger.setAttribute('aria-busy', isAdding ? 'true' : 'false');
  }

  function emitCartUpdate(cart, addResponse, trigger) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        sourceId: 'trp-home-plan-atc',
        data: {
          source: 'trp-home-plan-atc',
          itemCount: Number(cart.item_count || 0),
          productId: trigger.getAttribute('data-product-id') || '',
          variantId: trigger.getAttribute('data-variant-id') || '',
          sections: addResponse.sections || {}
        }
      }
    }));
  }

  function openCartDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    var openDrawer = function () {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }

      var trigger = drawer.querySelector('[on\\:click="/open"], button');
      if (trigger && typeof trigger.click === 'function') trigger.click();
    };

    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-drawer-component').then(function () {
        window.requestAnimationFrame(openDrawer);
      });
      return;
    }

    window.requestAnimationFrame(openDrawer);
  }

  async function addPlanToCart(trigger) {
    var variantId = trigger.getAttribute('data-variant-id');
    var sellingPlanId = trigger.getAttribute('data-selling-plan-id');
    var purchaseType = trigger.getAttribute('data-purchase-type');
    var item = {
      id: Number(variantId),
      quantity: 1
    };
    var sectionIds = cartSectionIds();
    var body = {
      items: [item],
      sections_url: window.location.pathname
    };

    if (purchaseType === 'subscription') {
      item.selling_plan = Number(sellingPlanId);
    }

    if (sectionIds.length) {
      body.sections = sectionIds.join(',');
    }

    setAddState(trigger, true);

    try {
      var addRequest = await fetch(routeUrl('cart_add_url', '/cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(body)
      });
      var addResponse = await addRequest.json();

      if (!addRequest.ok || addResponse.status) {
        throw new Error(addResponse.description || addResponse.message || 'Unable to add item to cart.');
      }

      var cartRequest = await fetch(cartJsonUrl(), {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      });
      var cart = await cartRequest.json();

      emitCartUpdate(cart, addResponse, trigger);
      openCartDrawer();
    } finally {
      setAddState(trigger, false);
    }
  }

  toArray(root.querySelectorAll('[data-trp-plan-atc]')).forEach(function (trigger) {
    trigger.addEventListener('click', function (event) {
      var variantId = trigger.getAttribute('data-variant-id');
      var sellingPlanId = trigger.getAttribute('data-selling-plan-id');
      var purchaseType = trigger.getAttribute('data-purchase-type');

      if (!variantId || (purchaseType === 'subscription' && !sellingPlanId)) return;
      if (trigger.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        return;
      }

      event.preventDefault();
      addPlanToCart(trigger).catch(function (error) {
        console.error(error);
        window.location.href = trigger.href;
      });
    });
  });

  toArray(root.querySelectorAll('.trp-home-faq__items')).forEach(function (faqGroup) {
    var faqItems = toArray(faqGroup.querySelectorAll('details'));

    faqItems.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;

        faqItems.forEach(function (otherItem) {
          if (otherItem !== item) otherItem.removeAttribute('open');
        });
      });
    });
  });

  var videos = toArray(root.querySelectorAll('.trp-home-video__card'));
  videos.forEach(function (card) {
    var video = card.querySelector('video');
    if (!video) return;

    function setPlaying(isPlaying) {
      card.classList.toggle('is-playing', isPlaying);
      card.setAttribute('aria-label', isPlaying ? 'Pause video review' : 'Play video review');
    }

    card.addEventListener('click', function () {
      if (video.paused) {
        videos.forEach(function (otherCard) {
          var otherVideo = otherCard.querySelector('video');
          if (otherVideo && otherVideo !== video) {
            otherVideo.pause();
            otherCard.classList.remove('is-playing');
            otherCard.setAttribute('aria-label', 'Play video review');
          }
        });

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            setPlaying(false);
          });
        }
        setPlaying(true);
      } else {
        video.pause();
        setPlaying(false);
      }
    });

    video.addEventListener('pause', function () {
      setPlaying(false);
    });

    video.addEventListener('ended', function () {
      video.currentTime = 0;
      setPlaying(false);
    });
  });

  var sticky = root.querySelector('[data-trp-home-sticky]');
  if (sticky) {
    var ticking = false;
    var updateSticky = function () {
      sticky.classList.toggle('is-visible', window.scrollY > 760);
      ticking = false;
    };

    updateSticky();
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateSticky);
    }, { passive: true });
  }

  var quiz = root.querySelector('[data-trp-quiz]');
  if (quiz) {
    var score = 0;
    var stepIndex = 0;
    var steps = toArray(quiz.querySelectorAll('[data-step]'));
    var progress = toArray(quiz.querySelectorAll('.trp-home-quiz__progress span'));
    var result = quiz.querySelector('[data-result]');
    var resultName = quiz.querySelector('[data-result-name]');
    var resultPrice = quiz.querySelector('[data-result-price]');
    var resultWas = quiz.querySelector('[data-result-was]');
    var resultDiscount = quiz.querySelector('[data-result-discount]');
    var resultCount = quiz.querySelector('[data-result-count]');
    var resultNote = quiz.querySelector('[data-result-note]');
    var resultLink = quiz.querySelector('[data-result-link]');
    var resultCta = quiz.querySelector('[data-result-cta]');
    var resetButton = quiz.querySelector('.trp-home-quiz__reset');

    var recommendations = [
      {
        name: '5-Patch Pouch',
        price: '$51.95',
        was: '$103.90',
        discount: '50% Off',
        count: '~ 5 patches / month',
        note: 'Perfect for testing the waters before committing.',
        url: '/products/that-red-patch-5-pack',
        cta: 'Try the 5-Pack'
      },
      {
        name: '10-Patch Pouch',
        price: '$80.96',
        was: '$89.95',
        discount: '10% Off',
        count: '~ 10 patches / month',
        note: 'Most popular pick for weekly support.',
        url: '/products/that-red-patch-10-pack',
        cta: 'Try the 10-Pack'
      },
      {
        name: '20-Patch Pouch',
        price: '$125.96',
        was: '$139.95',
        discount: '10% Off',
        count: '~ 20 patches / month',
        note: 'Best value for frequent or daily support.',
        url: '/products/that-red-patch-20-pack',
        cta: 'Try the 20-Pack'
      }
    ];

    function renderStep() {
      steps.forEach(function (step, index) {
        step.classList.toggle('is-active', index === stepIndex);
      });

      progress.forEach(function (bar, index) {
        bar.classList.toggle('is-active', index <= stepIndex);
      });
    }

    function showResult() {
      var rec = recommendations[score >= 3 ? 2 : score >= 1 ? 1 : 0];

      steps.forEach(function (step) {
        step.classList.remove('is-active');
      });

      progress.forEach(function (bar) {
        bar.classList.add('is-active');
      });

      if (resultName) resultName.textContent = rec.name;
      if (resultPrice) resultPrice.textContent = rec.price;
      if (resultWas) {
        resultWas.textContent = rec.was;
        resultWas.hidden = !rec.was;
      }
      if (resultDiscount) {
        resultDiscount.textContent = rec.discount;
        resultDiscount.hidden = !rec.discount;
      }
      if (resultCount) resultCount.textContent = rec.count;
      if (resultNote) resultNote.textContent = rec.note;
      if (resultLink) resultLink.setAttribute('href', rec.url);
      if (resultCta) resultCta.textContent = rec.cta;
      if (result) result.hidden = false;
    }

    toArray(quiz.querySelectorAll('.trp-home-quiz__step button')).forEach(function (button) {
      button.addEventListener('click', function () {
        score += parseInt(button.getAttribute('data-score') || '0', 10);
        stepIndex += 1;

        if (stepIndex >= steps.length) {
          showResult();
        } else {
          renderStep();
        }
      });
    });

    if (resetButton) {
      resetButton.addEventListener('click', function () {
        score = 0;
        stepIndex = 0;
        if (result) result.hidden = true;
        renderStep();
      });
    }

    renderStep();
  }
})();
